export enum AnalyseScoringIncompleteState {
  INITIAL = '[Scoring Incomplete State] Iniital state prior to loading attempt',
  LOADING = '[Scoring Incomplete State] Loading',
  LOADED_COMPLETE = '[Scoring Incomplete State] Loaded completely',
  LOADED_INCOMPLETE = '[Scoring Incomplete State] Loaded incompletely',
  ERROR = '[Scoring Incomplete State] Loading Error',
}
